import { render, staticRenderFns } from "./RonovatecUpDownButton.vue?vue&type=template&id=54e53183&scoped=true&"
import script from "./RonovatecUpDownButton.vue?vue&type=script&lang=ts&"
export * from "./RonovatecUpDownButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e53183",
  null
  
)

export default component.exports